import './_blurb-list.showcase.scss';

/**
 * Showcase layout for BlurbList - large, hero-like items with horizontal scroll.
 */
export default function BlurbListShowcase({ children, className = '' }) {
  if (!children) return null;

  return <div className={`BlurbList__showcase ${className}`}>{children}</div>;
}
